<!--
 * @Description: 
 * @Author: zml
 * @Date: 2026-06-22 11:06:09
 * @LastEditors: zml
 * @LastEditTime: 2026-07-01 10:20:10
-->
<template>
  <div class="container product-box">
    <div class="group-item" v-for="(item, index) in datas" :key="index">
      <div class="tit-box">
        <div class="titMore-box">
          <div class="tit">{{ language === "en" ? item.enTitle : language === "fr" ? item.rusTitle : item.title }}</div>
          <div class="more" @click="rapMore(item)">
            {{ $hs("更多", "More", "Plus") }}
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>

        <div class="group-img">
          <img
            :src="item.imgUrl"
            :alt="language === 'en' ? item.enTitle : language === 'fr' ? item.rusTitle : item.title"
          />
        </div>
      </div>
      <item-product :valueInfo="item.valueInfo"></item-product>
    </div>
  </div>
</template>
<script>
import itemProduct from "./itemProduct.vue";
import { mapState } from "vuex";
export default {
  name: "groupProduct",
  components: {
    itemProduct,
  },
  props: {
    datas: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState("user", ["userInfo"]),
    ...mapState("operate", ["language"]),
  },
  methods: {
    rapMore(item) {
      this.$router.push({
        path: "/product",
        query: { clNu: item.valueInfo },
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.product-box {
  .group-item {
    margin: 40px 0;

    .tit-box {
      width: 100%;

      .tit {
        font-size: 22px;
        font-weight: bold;
        margin: 35px 0px;
      }
      .titMore-box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .more {
          width: 90px;
          height: 30px;
          background: #3191d8;
          border-radius: 6px;
          font-size: 14px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          text-align: center;
          color: #ffffff;
          line-height: 30px;
          cursor: pointer;
        }
      }
      .group-img {
        width: 100%;

        img {
          width: 100%;
          border-radius: 10px;
        }
      }
    }
  }
}
</style>
